import React from "react";

const PresentedInfo = () => {
  return (
    <img
      src="https://cdn.ems.prod.upgather.com/uploads/Presented_By_FEDSCOOP_52433f9e9d.png"
      alt="Presented by Fedscoop"
      className="produced-image"
      />
  );
};

export default PresentedInfo;
